export default __webpack_public_path__ + "static/media/sopOpenIcon_disabled.bb6c6d04.svg";